export default "__VITE_ASSET__BsxtrRL3__"